import { sortBy } from "lodash";
import { useFieldArray, useFormContext } from "react-hook-form";
import { useParams } from "react-router-dom";
import { useGetPayersByAccountQuery } from "store/queries/payers";
import { IBenefitSelectionRule } from "types/Account/Account";

import { BenefitSelectionRules } from "./BenefitSelectionRules";

/**
 * CLE-2792 review round 10 — LEGACY's payer filters, bound to the ACCOUNT FORM and saved by
 * "Update Hospital" through `POST /accounts/benefitSelectionRules`.
 *
 * 🚨 SINCE 2026-09-28 THESE ARE LEGACY'S ROWS ONLY. The benefit selection card's step 2 edits the
 * engine's own filters, a separate table, so the two editors no longer share rows and neither can
 * move what the other system quotes.
 *
 * The table and dialog underneath are shared: `BenefitSelectionRules` is controlled, so this supplies
 * the value and the setter from the form and the card supplies them from its own state.
 */
export function BenefitSelectionRulesField() {
  const { control, watch } = useFormContext<any>();
  const { id: accountId } = useParams<{ id: string }>();

  const { data: payerByAccount, isLoading: loadingPayers } =
    useGetPayersByAccountQuery(accountId || "", { skip: !accountId });

  const payerOptions = sortBy(
    payerByAccount?.data?.map((payer: any) => ({
      label: payer.name,
      value: payer.id,
    })) || [],
    ["label"]
  );

  const { replace } = useFieldArray({
    control,
    name: "benefitSelectionRules",
  });

  // The field array's own `fields` snapshot does not track edits made through `replace`, so the
  // table reads the live form value instead.
  const rules: IBenefitSelectionRule[] = watch("benefitSelectionRules") || [];

  if (!accountId) {
    return (
      <span className="text-sm text-color-secondary">
        Payer filters can be added once the account has been created and its
        payers are known.
      </span>
    );
  }

  return (
    <BenefitSelectionRules
      value={rules}
      payerOptions={payerOptions}
      loadingPayers={loadingPayers}
      onChange={replace}
    />
  );
}
